import API from 'axios-config';
import { getDefaultParams } from 'helpers/tools';

function getUploadHistory(params) {
  return API.get('/droneftp-details', getDefaultParams({}, { queryStringParameters: params }))
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error('API Error:', error);
      return Promise.reject(error);
    });
}

function generateUrl(params, payload) {
  console.log("params",params)
  const config = getDefaultParams({}, { queryStringParameters: params });
  return API.put('/droneftps3upload', payload, config)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error('API Error:', error);
      return Promise.reject(error);
    });
}

function uploadToS3(payload) {
  const config = getDefaultParams({}, null);
  return API.post('/completes3upload', payload, config)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error('API Error:', error);
      return Promise.reject(error);
    });
}

function deleteHistory(params) {
  return API.delete('delete-history', getDefaultParams({}, { queryStringParameters: params }))
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error('API Error:', error);
      return Promise.reject(error);
    });
}

function getStripePaymentIntent(payload) {
  const config = getDefaultParams({}, null);
  return API.post('/stripe-payment-link', payload, config)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error('API Error:', error);
      return Promise.reject(error);
    });
}

function getStripePaymentStatus(params) {
  return API.get('/stripe-payment-status', getDefaultParams({}, { queryStringParameters: params }))
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error('API Error:', error);
      return Promise.reject(error);
    });
}

function getWalletBalance(params){
  return API.get('/stripe-payment-wallet-balance', getDefaultParams({}, { queryStringParameters: params }))
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error('API Error:', error);
      return Promise.reject(error);
    });
}


export const uploadServices = {
  getUploadHistory,
  generateUrl,
  uploadToS3,
  deleteHistory,
  getStripePaymentIntent,
  getStripePaymentStatus,
  getWalletBalance,
};
